import { useFela } from 'react-fela';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import type { ShareDetails } from '@/modules/api/codegen';
import { Text } from '@/modules/ui';
import { isEmptyOrUndefined } from '@/utilities/string';

import type { Secret } from '../../../../types';
import { SecretFieldSectionsByType } from '../../../SecretDetailSections';
import { SecretFieldSection } from '../../../SecretFieldSection';
import { SecretFile } from '../../../SecretFile';
import { SecretNameWithIcon } from '../../../SecretNameWithIcon';
import * as felaRules from './SharedSecretDetail.rules';

export interface SharedSecretDetailProps {
    secret: Secret;
    shareDetails?: ShareDetails;
}

export const SharedSecretDetail = ({ secret, shareDetails }: SharedSecretDetailProps) => {
    const { css } = useFela();
    const { note, file } = secret;
    const { until } = shareDetails ?? {};

    return (
        <>
            <div className={css(felaRules.header)}>
                {until && (
                    <Text variant='ParagraphSmallMedium' color='foregroundsTertiary' data-testid='shared-secret-valid-until'>
                        <FormattedMessage
                            id='sharedSecret.validUntil'
                            values={{
                                time: <FormattedTime value={until} />,
                                date: <FormattedDate value={until} day='numeric' month='numeric' year='numeric' />,
                            }}
                        />
                    </Text>
                )}
                <SecretFieldSection>
                    <SecretNameWithIcon secret={secret} />
                </SecretFieldSection>
            </div>
            <div className={css(felaRules.propertiesContainer)}>
                <SecretFieldSectionsByType secret={secret} />
                {file && (
                    <SecretFieldSection heading={<FormattedMessage id='secret.file' />}>
                        <SecretFile file={file} />
                    </SecretFieldSection>
                )}
                {!isEmptyOrUndefined(note) && (
                    <SecretFieldSection heading={<FormattedMessage id='secret.note' />}>
                        <Text preserveNewLines>{note}</Text>
                    </SecretFieldSection>
                )}
            </div>
        </>
    );
};
